import { useEffect, useState } from "react";
import { CATEGORIAS, getCategoria } from "@/lib/categorias";
import { getStatsCategorias } from "@/lib/ocorenApi";

export const CategoriaCard = ({ cat, total, percent, selected, onClick }) => {
  const Icon = cat.icon;
  return (
    <button
      data-testid={`categoria-card-${cat.key}`}
      onClick={onClick}
      className={`text-left bg-white border rounded-md p-4 transition-all hover:border-[#09090B] ${
        selected ? "border-[#09090B] ring-2 ring-[#09090B]/10" : "border-[#E4E4E7]"
      }`}
    >
      <div className="flex items-start justify-between">
        <div
          className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-sm text-[10px] uppercase tracking-[0.15em] font-bold ${cat.bg} ${cat.text} border ${cat.border}`}
        >
          <Icon size={11} />
          {cat.label}
        </div>
      </div>
      <div className="mt-3 font-heading text-2xl font-bold text-[#09090B] font-mono-data">
        {total.toLocaleString("pt-BR")}
      </div>
      <div className="text-[11px] text-[#52525B] mt-1 font-mono-data">
        {percent.toFixed(1)}% do total
      </div>
      <div className="mt-2 h-1 bg-[#FAFAFA] rounded-sm overflow-hidden">
        <div
          className="h-full transition-all"
          style={{ width: `${percent}%`, background: cat.color }}
        />
      </div>
    </button>
  );
};

/**
 * Grid de 5 categorias com totais e percent. Permite seleção (drill-down).
 * onSelect(categoria_key | null) chamado ao clicar.
 */
export const CategoriasGrid = ({ selected, onSelect, refreshKey = 0 }) => {
  const [data, setData] = useState({ categorias: [], total: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    getStatsCategorias()
      .then((d) => alive && setData(d))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [refreshKey]);

  const total = Math.max(1, data.total);

  return (
    <section data-testid="categorias-grid" className="space-y-3">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-[#52525B] font-bold">
            Distribuição por Status
          </div>
          <h2 className="font-heading text-lg font-semibold text-[#09090B] mt-1">
            Categorias
          </h2>
        </div>
        {selected && (
          <button
            onClick={() => onSelect?.(null)}
            data-testid="categoria-clear"
            className="text-xs text-[#52525B] hover:text-[#09090B] underline-offset-2 hover:underline"
          >
            Limpar seleção
          </button>
        )}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {CATEGORIAS.map((cat) => {
          const item = data.categorias.find((c) => c.key === cat.key);
          const t = item?.total ?? 0;
          return (
            <CategoriaCard
              key={cat.key}
              cat={cat}
              total={loading ? 0 : t}
              percent={loading ? 0 : (t / total) * 100}
              selected={selected === cat.key}
              onClick={() => onSelect?.(selected === cat.key ? null : cat.key)}
            />
          );
        })}
      </div>
    </section>
  );
};

export { getCategoria };
export default CategoriasGrid;
